// Presentation-only status badge for membership plans. Mirrors the
// VoucherStatusPill API so consumers see a unified pattern.

import { Badge } from '@bbpos/ui';
import type { MembershipPlanStatus } from './types';
import { planStatusMeta, toPlanStatus } from './status';

export interface MembershipStatusPillProps {
  /** Either the derived status enum, or a raw is_active boolean. */
  status?: MembershipPlanStatus;
  isActive?: boolean;
  size?: 'sm' | 'md';
}

export function MembershipStatusPill({ status, isActive, size = 'sm' }: MembershipStatusPillProps) {
  const resolved = status ?? (isActive != null ? toPlanStatus(isActive) : 'INACTIVE');
  const meta = planStatusMeta(resolved);
  return (
    <Badge variant={meta.badgeVariant} size={size}>
      <span className="flex items-center gap-1.5">
        <span className="h-1.5 w-1.5 rounded-full bg-current" />
        {meta.label}
      </span>
    </Badge>
  );
}
